/* eslint-disable line-comment-position, no-inline-comments */
import { ENTITIES } from '../input-entity/config.js';
export const normalizeText = (text) => {
    if (text === undefined) {
        return '';
    }
    if (text === '') {
        return '';
    }
    return text.normalize('NFD')
        .replace(/[\u0300-\u036f]/gu, '') // Remove diacritics
        .replace(/[æ]/gu, 'ae') // Replace ligatures
        .replace(/[œ]/gu, 'oe') // Replace ligatures
        .replace(/\./gu, ''); // Remove points
};
const getRegex = (entity) => {
    const NORMALIZED_ENTITY = normalizeText(entity);
    return new RegExp(`(?<=^|\\s)${NORMALIZED_ENTITY}(?=\\s|$)(?!.*${NORMALIZED_ENTITY}(?=\\s|$))`, 'giu');
};
export const getEntitiesByCountryCode = (countryCode) => {
    if (countryCode === undefined) {
        return [];
    }
    // Typescript doesn't know that countryCode is a specific string, so may result in undefined
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (ENTITIES[countryCode] === undefined) {
        return [];
    }
    return [...ENTITIES[countryCode]]
        .sort((entityA, entityB) => entityB.length - entityA.length)
        .map(entity => ({ name: entity, regex: getRegex(entity) }));
};
